$(document).ready(function() {
    
    // ========================== Faq accordian start =================================================
	if($('.js-cw-accordian').length > 0) {
        var faqAccordion = new Accordion({
            element: ".js-cw-accordian",
            activeTab: 1
        });
    }
    // ========================== Faq accordian end =================================================

});

